module.exports = __webpack_public_path__ + "img/2.7ee9b164.jpg";